import React from 'react';

import useOrgUnitDropdown from './UseOrgUnitDropdown';

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const OrgUnitDropdown = ({ label, name, value, error, message, reportInfoId, onChange }) => {
  const { orgUnitState } = useOrgUnitDropdown(reportInfoId);

  return orgUnitState?.message
    ? <span className={global.LoadingMsg}>{orgUnitState.message}</span>
    : (
      <Dropdown
        error={error}
        label={label}
        message={message}
        options={orgUnitState.options}
        name={name}
        value={value}
        onChange={onChange}
        areValuesIntegers={true}
        isLoading={orgUnitState?.isArrayLoading} />
    );
};

export default OrgUnitDropdown;